module.exports = __webpack_public_path__ + "static/media/comptuer-science.86dc4692.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/categories/comptuer-science.png
// module id = 483
// module chunks = 0